(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', e => {
    const step = e.target.closest('[data-slap-qty] [data-step]');
    if (step) {
      const wrap = step.closest('[data-slap-qty]');
      const input = wrap.querySelector('input');
      const min = parseInt(input.min || '0', 10), max = parseInt(input.max || '999', 10);
      input.value = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const thumb = e.target.closest('[data-slap-thumb]');
    if (thumb) {
      const g = thumb.closest('.slap-gallery');
      g.querySelector('[data-slap-gallery-main]').src = thumb.dataset.slapThumb;
      g.querySelectorAll('[data-slap-thumb]').forEach(t => t.toggleAttribute('aria-current', t === thumb));
    }
    const vid = e.target.closest('[data-slap-video]');
    if (vid && vid.dataset.slapVideo && !vid.querySelector('iframe')) {
      const f = document.createElement('iframe');
      f.src = vid.dataset.slapVideo; f.allow = 'autoplay; fullscreen; picture-in-picture'; f.allowFullscreen = true; f.title = 'Probelektion';
      vid.appendChild(f);
    }
    const tab = e.target.closest('[data-slap-tab]');
    if (tab) {
      const box = tab.closest('[data-slap-tabs]');
      box.querySelectorAll('[data-slap-tab]').forEach(b => { const on = b === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
      box.querySelectorAll('[data-slap-panel]').forEach(p => { p.hidden = p.dataset.slapPanel !== tab.dataset.slapTab; });
    }
  });

  document.addEventListener('change', e => {
    const qty = e.target.closest('[data-slap-qty][data-autosubmit] input');
    if (qty) { clearTimeout(qty._t); qty._t = setTimeout(() => qty.form.submit(), 350); }

    const radio = e.target.closest('.slap-choice input[type=radio]');
    if (radio) {
      const section = radio.closest('[data-slap-product]');
      section.querySelector('[data-slap-variant-id]').value = radio.value;
      section.querySelectorAll('[data-slap-net]').forEach(el => { el.textContent = radio.dataset.net; });
      section.querySelectorAll('[data-slap-gross]').forEach(el => { el.textContent = radio.dataset.gross; });
      const sv = section.querySelector('[data-slap-sticky-variant]'); if (sv) sv.textContent = ' · ' + radio.dataset.label;
      section.querySelector('[data-slap-per-unit]').textContent = radio.dataset.perUnit || '';
      const btn = section.querySelector('[data-slap-submit]'), ok = radio.dataset.available === 'true';
      btn.disabled = !ok;
      btn.classList.toggle('slap-btn--primary', ok); btn.classList.toggle('slap-btn--navy', !ok);
      btn.textContent = ok ? 'In den Warenkorb' : 'Nicht mehr verfügbar';
      const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState({}, '', url);
    }
  });

  const sticky = document.querySelector('[data-slap-sticky]');
  const mainBtn = document.querySelector('[data-slap-product] [data-slap-submit]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.hidden = !show; document.body.classList.toggle('slap-has-sticky', show);
    }).observe(mainBtn);
  }

  const setCount = n => document.querySelectorAll('[data-slap-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; });
  const toast = msg => {
    const t = document.querySelector('[data-slap-toast]'); if (!t) return;
    t.querySelector('[data-slap-toast-text]').textContent = msg; t.hidden = false;
    clearTimeout(t._t); t._t = setTimeout(() => { t.hidden = true; }, 3500);
  };

  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-slap-ajax]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = form.querySelector('[data-slap-submit]'); btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const item = await res.json();
      if (!res.ok) throw new Error(item.description || 'Fehler');
      const cart = await (await fetch(root + 'cart.js')).json();
      setCount(cart.item_count);
      toast(form.querySelector('[name=quantity]').value + ' × ' + item.product_title + ' im Warenkorb');
      form.querySelector('[name=quantity]').value = 1;
    } catch (err) { toast(err.message); }
    btn.disabled = false;
  });

  document.addEventListener('click', async e => {
    const up = e.target.closest('[data-slap-upgrade]');
    if (!up || !window.fetch) return;
    e.preventDefault();
    await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: up.dataset.from, quantity: 0 }) });
    await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(up.dataset.to), quantity: Number(up.dataset.qty) }] }) });
    location.reload();
  });
})();
